<div
  class="flex align-items-center justify-content-center top-header-tab relative active-tab"
>
  <a class="inner-tab-container">
    <div class="inner-tab flex align-items-center gap-1">
      <span class="webkit-box-one-line body-medium-medium">{{ title() }}</span>
    </div>
  </a>
  <div class="active-right"></div>
</div>
